import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { contestsBackend } from './contests.backend';
import { contestsReducer } from './contests.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('contests', contestsReducer),
    BackendModule.forFeature('contests', contestsBackend),
  ],
})
export class DatastoreContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contests/contests.module.ts